import { getApiUrlPath } from '@/models/constant'
import { GenericService } from '@/models/shared'
import { IPolicyEventResponse } from './response'
import { IPolicyEventRequest } from './request'


export class PolicyEventFactory extends GenericService<IPolicyEventRequest,
  IPolicyEventResponse> {
  constructor() {
    super({
      prefix: getApiUrlPath('PolicyEvent')
    })
  }
}

